// @ts-ignore
import ApiClient from '../api-client/apiClient';
// @ts-ignore
import { getAccessToken, setAccessToken, setAuthorizationToken } from '../auth';
// @ts-ignore
import { PORT, apiUrl, version } from '../environment';

import { notification } from 'antd';
import { loginSuccess, registerSuccess, loginFailed } from '@store/Auth/user';
import { handleIsLoading, handleLoading } from '@store/general';
import axios from 'axios';
type NotificationType = 'success' | 'info' | 'warning' | 'error';

function openNotificationWithIcon(type: NotificationType, message: string) {
    notification[type]({
        message: message,
        placement: 'topRight', // You can change the placement if needed
    });
}

const tokenRaw: any = getAccessToken();
const token = `Bearer ${tokenRaw}`;

export const userLogin = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleLoading(true));
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/login`, data).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    openNotificationWithIcon('success', response.message);
                    dispatch(loginSuccess(response));
                    setAccessToken(response?.token);
                    if (response?.token) {
                        setAuthorizationToken(axios, response?.token);
                        sessionStorage.setItem('token', response?.token)
                    }
                    dispatch(handleLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleLoading(false));
                    // return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleLoading(false));
                }
            }
        );
    };
};

export const userLogout = (callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/logout`, {}, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    openNotificationWithIcon('success', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    callback(response);
                }
            }
        );
    };
};
export const resetPassword = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleLoading(true));
        ApiClient.post(
            `${apiUrl}${PORT}${version}/admin/forgot-password`,
            data
        ).then((response: any) => {
            if (response.status === 200 || response.status === 201) {
                openNotificationWithIcon('success', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else if (response.status === 404) {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
            }
        });
    };
};

export const changePassword = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleLoading(true));
        ApiClient.post(
            `${apiUrl}${PORT}${version}/admin/reset-password`,
            data,
            token,
            dispatch
        ).then((response: any) => {
            if (response.status === 200 || response.status === 201) {
                openNotificationWithIcon('success', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else if (response.status === 404) {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
            }
        });
    };
};

// change-password after login 
export const changeAccountPassword = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleLoading(true));
        ApiClient.patch(
            `${apiUrl}${PORT}${version}/admin/change-password`,
            data,
            token,
            dispatch
        ).then((response: any) => {
            if (response.status === 200 || response.status === 201) {
                openNotificationWithIcon('success', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else if (response.status === 404) {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
                return callback(response);
            } else {
                openNotificationWithIcon('error', response.message);
                dispatch(handleLoading(false));
            }
        });
    };
};


export const checkuser = (callback: any) => {
    return (dispatch: any, getState: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        try {
            if (tokenRaw) {
                ApiClient.get(
                    `${apiUrl}${PORT}${version}/admin/my-profile`,
                    {},
                    token,
                    dispatch
                ).then((response: any) => {
                    if (response.status === 200) {
                        const actionData = {
                            ...response,
                            data: response?.user,
                        };
                        dispatch(loginSuccess(actionData));
                       return callback(response);
                    } else if (response.status === 404 || response.status === 401) {
                        dispatch(loginFailed(response));
                       return callback(response);
                    } else {
                        dispatch(loginFailed(response));
                        return callback(response);
                    }
                }).catch((error:any)=> {
                    dispatch(loginFailed(error));
                    return callback(error);
                });
            }
        } catch (err) {
            if (err) {
                dispatch(loginFailed(err));
            }
        }
    };
};

export const user = (params: any) => {
    return (dispatch: any, getState: any) => {
        const {
            user: { token },
        } = getState();
        dispatch({ type: 'ISLOADING', data: true });
        ApiClient.get(`${apiUrl}${PORT}/users`, params, token, dispatch).then(
            (response: any) => {
                dispatch({ type: 'ISLOADING', data: false });

                if (response.messageID === 200) {
                    dispatch({ type: 'LIST_USERS', data: response.data });
                } else if (response.messageID === 404) {
                    // toast.warn(response.message);
                } else {
                    // toast.error(response.message);
                }
            }
        );
    };
};

// *********** register referrer **********************
export const userRegister = (data: any, callback: any) => {
    return (dispatch: any) => {
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/register`, data).then(
            (response: any) => {
                // dispatch({ type: 'ISLOADING', data: false });
                if (response.status === 200 || response.status === 201) {
                    openNotificationWithIcon('success', response.message);
                    dispatch(registerSuccess(response.data));
                    return callback(response);
                } else if (response.status === 404) {
                    openNotificationWithIcon('error', response.message);
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                }
            }
        );
    };
};

// *********** update acount details **********************
export const updateUserDetails = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.patchFormData(`${apiUrl}${PORT}${version}/admin/profile`, data, token, dispatch).then(
            (response: any) => {
                // dispatch({ type: 'ISLOADING', data: false });
                dispatch(handleLoading(false));
                if (response.status === 200 || response.status === 201) {
                    openNotificationWithIcon('success', response.message);
                    // const actionData = {
                    //     ...response,
                    //     data: response?.user,
                    // };
                    // dispatch(loginSuccess(actionData));
                    dispatch(handleLoading(false));
                    return callback(response);
                } else if (response.status === 404 || response.status === 400) {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response.message);
                    return callback(response);
                } else {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response.message);
                }
            }
        );
    };
};


export const forgot_password = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch({ type: 'ISLOADING', data: true });
        ApiClient.get(`${apiUrl}${PORT}/auth/forgot-password`, data).then(
            (response: any) => {
                dispatch({ type: 'ISLOADING', data: false });

                if (response.messageID === 200) {
                    // toast.success(response.message);
                    dispatch({ type: 'FORGOTPASSWORD', data });
                    return callback(response);
                } else if (response.messageID === 404) {
                    // toast.warn(response.message);
                    return callback(response);
                } else {
                    // toast.error(response.message);
                }
            }
        );
    };
};

export const check_password_token = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch({ type: 'ISLOADING', data: true });
        ApiClient.get(
            `${apiUrl}${PORT}/auth/check-password-token/${data.token}`,
            dispatch
        ).then((response: any) => {
            dispatch({ type: 'ISLOADING', data: false });

            if (response.messageID === 200) {
                // toast.success(response.message);
                dispatch({ type: 'PASSWORDTOKEN', data: response.data });
                // return callback(response);
            } else if (response.messageID === 404) {
                // toast.warn(response.message);
                // return callback(response);
            } else {
                // toast.error(response.message);
            }
        });
    };
};

export const logout = (data: any, callback: any) => {
    return (dispatch: any, getState: any) => {
        dispatch({ type: 'ISLOADING', data: true });
        const {
            user: { token },
        } = getState();
        localStorage.setItem('LOGOUT', JSON.stringify(true));
        ApiClient.get(
            `${apiUrl}${PORT}/auth/logout`,
            data,
            token,
            dispatch
        ).then((response: any) => {
            dispatch({ type: 'ISLOADING', data: false });

            if (response.messageID === 200) {
                // toast.success(response.message);
                dispatch({ type: 'LOGOUT', data: {} });
                dispatch({ type: 'DETAILS_GROUP', data: {} });
                return callback(response);
            } else if (response.messageID === 404) {
                return callback(response);
            } else {
                dispatch({ type: 'LOGOUT', data: {} });
                // toast.error(response.message);
            }
        });
    };
};

export const loader = (flag: any) => {
    return (dispatch: any, getState: any) => {
        dispatch({ type: 'ISLOADING', data: flag });
    };
};

export const set_active_tab = (tab: any) => {
    return (dispatch: any, getState: any) => {
        dispatch({ type: 'SET_ACTIVE_TAB', data: tab });
    };
};

// *********** connect mindbody **********************
export const connectMindbody = (callback?: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/admin/mindbody/connect?returnUrl=1`, {} , token)
            .then((response: any) => {
                if (response.status === 200 && response.data?.url) {
                    // console.log("response-------------",response)
                    // redirect to Mindbody OAuth
                    // window.location.href = response.data.url;

                    if (callback) return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    if (callback) return callback(response);
                }
            })
            .catch((error: any) => {
                openNotificationWithIcon('error', error?.response?.data?.message || 'Mindbody connect failed');
                if (callback) return callback(error);
            });
    };
};


// *********** check mindbody status **********************
export const getMindbodyStatus = (callback?: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/admin/mindbody/status`,{},token)
            .then((response: any) => {
                if (response.status === 200) {
                    dispatch({ type: "MINDBODY_STATUS", data: response.data });

                    if (callback) return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    if (callback) return callback(response);
                }
            })
            .catch((error: any) => {
                openNotificationWithIcon('error', error?.response?.data?.message || 'Failed to fetch Mindbody status');
                if (callback) return callback(error);
            });
    };
};

// *********** disconnect mindbody **********************
export const disconnectMindbody = (callback?: any) => {
    return (dispatch: any) => {
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/mindbody/disconnect`)
            .then((response: any) => {
                if (response.status === 200) {

                    openNotificationWithIcon('success', response.message);

                    dispatch({ type: "MINDBODY_DISCONNECTED" });

                    if (callback) return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    if (callback) return callback(response);
                }
            })
            .catch((error: any) => {
                openNotificationWithIcon('error', error?.response?.data?.message || 'Disconnect failed');
                if (callback) return callback(error);
            });
    };
};

// *********** mindbody oauth callback **********************
export const mindbodyOAuthCallback = (data: any, callback?: any) => {
    return (dispatch: any) => {
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/mindbody/oauth/callback`, data)
            .then((response: any) => {

                if (response.status === 200 || response.status === 201) {

                    openNotificationWithIcon('success', response.message);

                    dispatch({ type: "MINDBODY_CONNECTED", data: response.data });

                    if (callback) return callback(response);

                } else {
                    openNotificationWithIcon('error', response.message);
                    if (callback) return callback(response);
                }

            })
            .catch((error: any) => {
                openNotificationWithIcon('error', error?.response?.data?.message || 'OAuth callback failed');
                if (callback) return callback(error);
            });
    };
};